/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiUpdateCaseDetailsRequest
 */
export interface InternalApiUpdateCaseDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalApiUpdateCaseDetailsRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiUpdateCaseDetailsRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiUpdateCaseDetailsRequest
     */
    rationaleCode: string;
}

/**
 * Check if a given object implements the InternalApiUpdateCaseDetailsRequest interface.
 */
export function instanceOfInternalApiUpdateCaseDetailsRequest(value: object): value is InternalApiUpdateCaseDetailsRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('rationaleCode' in value) || value['rationaleCode'] === undefined) return false;
    return true;
}

export function InternalApiUpdateCaseDetailsRequestFromJSON(json: any): InternalApiUpdateCaseDetailsRequest {
    return InternalApiUpdateCaseDetailsRequestFromJSONTyped(json, false);
}

export function InternalApiUpdateCaseDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiUpdateCaseDetailsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'rationaleCode': json['rationaleCode'],
    };
}

export function InternalApiUpdateCaseDetailsRequestToJSON(json: any): InternalApiUpdateCaseDetailsRequest {
    return InternalApiUpdateCaseDetailsRequestToJSONTyped(json, false);
}

export function InternalApiUpdateCaseDetailsRequestToJSONTyped(value?: InternalApiUpdateCaseDetailsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'rationaleCode': value['rationaleCode'],
    };
}

